(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("examAttemptRequestApproval", function () {
        return {
            restrict: "E",
            scope: {},
            templateUrl: "app/public/examAttemptRequestApprovalView.html",
            controllerAs: "vm",
            bindToController: true,
            controller: ["publicResource", "messageService", "$stateParams", ExamAttemptRequestApprovalCtrl]
        };
        function ExamAttemptRequestApprovalCtrl(publicResource, messageService, $stateParams) {
            var vm = this;
            vm.loading = true;
            vm.showErrors = false;
            vm.errorLoading = false;
            vm.formData = {
                approved: $stateParams["a"] === "1",
                requestId: $stateParams["t"],
                username: $stateParams["u"]
            };
            publicResource.getExamAttemptRequest($stateParams, function (result) {
                vm.data = result;
                vm.loading = false;
            }, function (error) {
                vm.errorLoading = true;
                vm.loading = false;
                messageService.error(error);
            });
            vm.submit = function () {
                vm.showErrors = true;
                if (vm.form.$valid) {
                    publicResource.saveExamAttemptRequestResult(vm.formData, function (result) {
                        vm.data = result;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
            };
        }
    });
}());
